import { render, staticRenderFns } from "./Actinfo.vue?vue&type=template&id=7319ec0c&scoped=true"
import script from "./Actinfo.vue?vue&type=script&lang=js"
export * from "./Actinfo.vue?vue&type=script&lang=js"
import style0 from "./Actinfo.vue?vue&type=style&index=0&id=7319ec0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7319ec0c",
  null
  
)

export default component.exports